import React from "react";
import { useBCMSModal } from "bcms-react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton, ModalSecondaryButton } from "components/custom-ui/CustomModal";

import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import { Participant } from "model";
import "./styles.css";
import "./mobile.css";
/**
 * @function PassThruACHDetailsModal
 * @param {FUNCTION} onClick - Allows us to set an event handler on click to the primary modal button. 
 * @exported true
 * @returns {React.Component}
 * @description 
 * @example
 * <PassThruACHDetailsModal />
 */

export default function PassThruACHDetailsModal(props) {
  const { close } = useBCMSModal();
  const data = props.data.data ?? {};
  const { onShowRawContent, onShowFormattedContent, onPassThruACHDetailCloseModalClick, showFormattedContent } = props.data.modalData ?? {}
  const participants = data.participants ? Participant.initAll().filter(item => item.id.toString() === data.participants[item.id])[0] : [];
  const participantName = participants ? participants.nickname : "";

  const onClick = evt => {
    onPassThruACHDetailCloseModalClick();
    close("PassThruACHDetailsModal");
  }
  return (
    <CustomModal title={data.fileName} id="PassThruACHDetailsModal" className="pass-thru-ach-details-modal" onCloseClick={onClick}>
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <p className="sub-text">Created by {data.createdBy} ({data.companyAccount.name}) - {data.createdDate.format()}</p>
        <p className="sub-text">Approved by System</p>
        <p className="sub-text">Pending Approval (Pending FI Approval)</p>
        <p><b>File Creation Date: </b>{data.createdDate.format("m/d/Y")}, <b>Origin: </b>(123456780), <b>Destination: </b>(123456780)</p>
        <p><b>File Totals: Credits: </b>{data.creditAmount.format()}, <b>Debits: </b>{data.debitAmount.format()}</p>
        <p><b>{data.secCode} Batch {`#${data.batchNumber}`}, </b> Effective Date: {data.createdDate.format("m/d/Y")}, Company: {participantName}</p>
        {showFormattedContent &&

          <TableView className="pass-thru-ach-details-table">
            <TableColumnContainer>
              <TableColumnView text="Account Type"  className="account-type-column"/>
              <TableColumnView text="Routing Number"  className="routing-number-column"/>
              <TableColumnView text="Account Number" className="account-number-column" />
              <TableColumnView text="Credit" />
              <TableColumnView text="Debit" className="debit-header-column" />
              <TableColumnView text="Participant" className="show-on-desktop" />
            </TableColumnContainer>
            <TableBody>
              <TableItemContainer>
                <TableItemTextView text={data.offsetAccount.nickname}  className="account-type-column" />
                <TableItemTextView text={data.offsetAccount.routingNumber} className="routing-number-column" />
                <TableItemTextView text={data.offsetAccount.number} className="text-right account-number-column" />
                <TableItemTextView text="" className="credit-column" />
                <TableItemTextView text={data.debitAmount.format()} className="debit-column" />
                <TableItemTextView text={`PARTICIPANT 1`} className="show-on-desktop" />
              </TableItemContainer>
              <TableItemContainer>
                <TableItemView />
                <TableItemView />
                <TableItemTextView text="Totals:" className="text-right account-number-column total" />
                <TableItemTextView text="" className="credit-column" />
                <TableItemTextView text={data.debitAmount.format()} className="debit-column" />
                <TableItemView className="show-on-desktop" />
              </TableItemContainer>
            </TableBody>
          </TableView>
        }

        {!showFormattedContent &&
          <span className="raw-content">101&nbsp;123456780&nbsp;1234567802012071500B094101&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NA&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />
            5220<span className="participant-name">{participantName}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{data.rawFileName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;201207201207&nbsp;&nbsp;&nbsp;1243374210000260
            <br />
            6222219823891111111111&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;00000012501111111111&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PARTICIPANT&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0243374210000003
            <br />
            822000000100221982380000000000000000000012509202011252&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;243374210000260
            <br />
            9999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999
            <br />
            9999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999
            <br />
          </span>
        }


      </CustomModalContent>
      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
        {showFormattedContent && <ModalPrimaryButton text="Show Raw Contents" onClick={onShowRawContent} dataPoint="Show_Raw_Content_Button" />}
        {!showFormattedContent && <ModalPrimaryButton text="Show Formatted" onClick={onShowFormattedContent}  dataPoint="Show_Formatted_Content_Button"/>}
        <ModalSecondaryButton text="Close" id="PassThruACHDetailsModal" onClick={onClick} dataPoint="Close_Modal_Button"/>
      </CustomModalFooter>
    </CustomModal>
  )
}
